import AISummary from './AISummary';
import KPIPills from './KPIPills';

export default function StatusCockpit({ lead, summary, refreshKey, onChanged, onSummaryLoaded }) {
  return (
    <div className="space-y-3">
      <AISummary leadId={lead.id} refreshKey={refreshKey} onLoaded={onSummaryLoaded} />
      <KPIPills lead={lead} summary={summary} onChanged={onChanged} />
    </div>
  );
}
